import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { SettingsFilled } from "@fluentui/react-icons";

export default function SettingsPage() {
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            updateDocumentTitle( "Settings | General Settings" );
            navData.sidebarSelectedNavValue = "settings";
            navData.subPageNavValue = null;
            setNavData({...navData});
        },
        []
    );

    return (
        <>
            <SubPageTitle icon={<SettingsFilled />} title="Settings" subTitle="General Settings" />
        </>
    );
}